import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';

import App from './App';
import reportWebVitals from './reportWebVitals';
import i18n from './translations/i18n';

import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <I18nextProvider i18n={i18n}>
    <App />
  </I18nextProvider>
);

reportWebVitals();
